var $ffe46bb88767ca45$exports = {};
$ffe46bb88767ca45$exports = {
    "valid": `Valido`
};


export {$ffe46bb88767ca45$exports as default};
//# sourceMappingURL=it-IT.module.js.map
